interface NumberArrayMap {
  [index: string]: number[];
}

interface StringArray {
  [index: string]: string;
}

export default class SensorLimits {
  public static colors: StringArray = {
    future: "#45a3c2",
    past: "#94a60d"
  };

  public static getColor(limitName: string) {
    return this.colors[limitName];
  }
}
